"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Sync_1 = require("@twii/core-ui-fabric/lib/component/Sync");
var IListingSupplierProps = /** @class */ (function () {
    function IListingSupplierProps() {
    }
    return IListingSupplierProps;
}());
exports.IListingSupplierProps = IListingSupplierProps;
var ListingSupplierContainer = /** @class */ (function (_super) {
    __extends(ListingSupplierContainer, _super);
    function ListingSupplierContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderDone = function () {
            return _this.props.onRenderListing(_this.props.listingSupplier.value);
        };
        return _this;
    }
    ListingSupplierContainer.prototype.render = function () {
        return React.createElement(Sync_1.Sync, { sync: this.props.listingSupplier.sync, onRenderDone: this._onRenderDone });
    };
    return ListingSupplierContainer;
}(React.Component));
exports.ListingSupplierContainer = ListingSupplierContainer;
